import { Button } from '@zillow/constellation-10';
import { useContext, useState } from 'react';
import { AppContext } from '../../contexts/AppContextProvider';
import useTourActionClickstream from '../../hooks/useTourActionClickstream';
import AddManualTourModal from '../Modals/AddManualTourModal';

type AddTourButtonProps = {
  conversationId: string;
  leadId?: string | null;
  listingAlias: string;
  /** The landlord's notepad tour time, used to prefill the form. */
  notedTourStartMs?: number;
};

export default function AddTourButton({ conversationId, leadId, listingAlias, notedTourStartMs }: AddTourButtonProps) {
  const { isImpersonator } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const { eventTypeId, fireTourActionEvent } = useTourActionClickstream({ leadId, listingAlias });

  return (
    <>
      {showModal && (
        <AddManualTourModal
          conversationId={conversationId}
          initialStartTimeMs={notedTourStartMs}
          onClose={() => setShowModal(false)}
        />
      )}
      <Button
        data-eventid={eventTypeId}
        disabled={isImpersonator}
        emphasis="outlined"
        fluid
        onClick={() => {
          fireTourActionEvent('add_tour');
          setShowModal(true);
        }}
        size="sm"
        tone="neutral"
      >
        Add tour to calendar
      </Button>
    </>
  );
}
